import { useEffect, useMemo } from 'react';

export const useAnchorElement = (position: { x: number; y: number } | null) => {
  const referenceElement = useMemo(() => {
    const element = document.createElement('div');

    element.id = 'action-item-popover-referance';

    element.style.position = 'absolute';
    element.style.left = `${position?.x ?? 0}px`;
    element.style.top = `${position?.y ?? 0}px`;
    element.style.zIndex = '9999';

    return element;
  }, [position]);

  useEffect(() => {
    document.body.appendChild(referenceElement);

    return () => {
      document.body.removeChild(referenceElement);
    };
  }, [referenceElement]);

  return referenceElement;
};
